export const MFA_SETUP_REQUEST = 'app/MFA/MFA_SETUP_REQUEST';
export const MFA_SETUP_SUCCESS = 'app/MFA/MFA_SETUP_SUCCESS';
export const MFA_SETUP_ERROR = 'app/MFA/MFA_SETUP_ERROR';

export const MFA_VERIFY_REQUEST = 'app/MFA/MFA_VERIFY_REQUEST';
export const MFA_VERIFY_SUCCESS = 'app/MFA/MFA_VERIFY_SUCCESS';
export const MFA_VERIFY_ERROR = 'app/MFA/MFA_VERIFY_ERROR';

export const MFA_STATUS_REQUEST = 'app/MFA/MFA_STATUS_REQUEST';
export const MFA_STATUS_SUCCESS = 'app/MFA/MFA_STATUS_SUCCESS';
export const MFA_STATUS_ERROR = 'app/MFA/MFA_STATUS_ERROR';

export const MFA_DISABLE_REQUEST = 'app/MFA/MFA_DISABLE_REQUEST';
export const MFA_DISABLE_SUCCESS = 'app/MFA/MFA_DISABLE_SUCCESS';
export const MFA_DISABLE_ERROR = 'app/MFA/MFA_DISABLE_ERROR';

export const MFA_REGENERATE_BACKUP_CODES_REQUEST =
  'app/MFA/MFA_REGENERATE_BACKUP_CODES_REQUEST';
export const MFA_REGENERATE_BACKUP_CODES_SUCCESS =
  'app/MFA/MFA_REGENERATE_BACKUP_CODES_SUCCESS';
export const MFA_REGENERATE_BACKUP_CODES_ERROR =
  'app/MFA/MFA_REGENERATE_BACKUP_CODES_ERROR';

export const MFA_LOGIN_SUCCESS = 'app/MFA/MFA_LOGIN_SUCCESS';
export const MFA_LOGIN_ERROR = 'app/MFA/MFA_LOGIN_ERROR';

export const MFA_IN_PROGRESS_END = 'app/MFA/MFA_IN_PROGRESS_END';

export const MFA_SETUP_REQUIRED = 'app/MFA/MFA_SETUP_REQUIRED';
export const MFA_SETUP_REQUIRED_CLEAR = 'app/MFA/MFA_SETUP_REQUIRED_CLEAR';

export const MFA_ENFORCEMENT_FETCH_REQUEST =
  'app/MFA/MFA_ENFORCEMENT_FETCH_REQUEST';
export const MFA_ENFORCEMENT_FETCH_SUCCESS =
  'app/MFA/MFA_ENFORCEMENT_FETCH_SUCCESS';
export const MFA_ENFORCEMENT_FETCH_ERROR =
  'app/MFA/MFA_ENFORCEMENT_FETCH_ERROR';

export const MFA_ENFORCEMENT_UPDATE_REQUEST =
  'app/MFA/MFA_ENFORCEMENT_UPDATE_REQUEST';
export const MFA_ENFORCEMENT_UPDATE_SUCCESS =
  'app/MFA/MFA_ENFORCEMENT_UPDATE_SUCCESS';
export const MFA_ENFORCEMENT_UPDATE_ERROR =
  'app/MFA/MFA_ENFORCEMENT_UPDATE_ERROR';

export const MFA_TRUSTED_DEVICES_FETCH_REQUEST =
  'app/MFA/MFA_TRUSTED_DEVICES_FETCH_REQUEST';
export const MFA_TRUSTED_DEVICES_FETCH_SUCCESS =
  'app/MFA/MFA_TRUSTED_DEVICES_FETCH_SUCCESS';
export const MFA_TRUSTED_DEVICES_FETCH_ERROR =
  'app/MFA/MFA_TRUSTED_DEVICES_FETCH_ERROR';

export const MFA_TRUSTED_DEVICE_REVOKE_REQUEST =
  'app/MFA/MFA_TRUSTED_DEVICE_REVOKE_REQUEST';
export const MFA_TRUSTED_DEVICE_REVOKE_SUCCESS =
  'app/MFA/MFA_TRUSTED_DEVICE_REVOKE_SUCCESS';
export const MFA_TRUSTED_DEVICE_REVOKE_ERROR =
  'app/MFA/MFA_TRUSTED_DEVICE_REVOKE_ERROR';

export const MFA_TRUSTED_DEVICES_REVOKE_ALL_REQUEST =
  'app/MFA/MFA_TRUSTED_DEVICES_REVOKE_ALL_REQUEST';
export const MFA_TRUSTED_DEVICES_REVOKE_ALL_SUCCESS =
  'app/MFA/MFA_TRUSTED_DEVICES_REVOKE_ALL_SUCCESS';
export const MFA_TRUSTED_DEVICES_REVOKE_ALL_ERROR =
  'app/MFA/MFA_TRUSTED_DEVICES_REVOKE_ALL_ERROR';

export const MFA_USER_RESET_REQUEST = 'app/MFA/MFA_USER_RESET_REQUEST';
export const MFA_USER_RESET_SUCCESS = 'app/MFA/MFA_USER_RESET_SUCCESS';
export const MFA_USER_RESET_ERROR = 'app/MFA/MFA_USER_RESET_ERROR';
